import React, { useState } from "react";
import { connect } from "react-redux";
import ct from "class-types.macro";
import formatAsCurrency from "@wss/utilities/formatAsCurrency";
import { CategoryTopProductResult } from "~/common/Store/models/Category";
import NoScriptLazyImage from "~/common/NoScriptLazyImage";
import { SelectedProduct } from "~/common/Store/models/ProductListing";
import AddToCartButton from "../productListing/ProductBox/AddToCart";
import { RootState, UserState } from "~/common/Store/models/RootReadonly";
interface Props {
  topProduct: CategoryTopProductResult;
  user: UserState;
}
const TopProductsGridMember = ({
  topProduct,
  user
}: Props) => {
  const {
    product
  } = topProduct;
  const [selectedProduct, setSelectedProduct_og] = useState<SelectedProduct>({
    ...topProduct.product,
    activeSale: product.price.displaySalePrice,
    isOutlet: product.outletAttributes && product.outletAttributes.isOutlet
  });

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  function setSelectedProduct(args: any) {
    console.log("setSelectedProduct_og");
    setSelectedProduct_og.call(null, args);
  }
  return <div key={topProduct.itemNumber} className={`ag-item gtm-product ${ct("inline-block")}`} data-sentry-component="TopProductsGridMember" data-sentry-source-file="TopProductsGridMember.tsx">
      <div className="product-image">
        <a href={topProduct.link} title={topProduct.description} data-testid="itemImageLink" data-label={product.feedIdentifier} data-action="click">
          <NoScriptLazyImage className="lazyLoad Grid" src={topProduct.thumbnailImage} alt={topProduct.description} data-sentry-element="NoScriptLazyImage" data-sentry-source-file="TopProductsGridMember.tsx" />
        </a>
      </div>
      <div>
        <a className="description" href={topProduct.link} title={topProduct.description} data-testid="itemDescriptionLink" data-label={product.feedIdentifier} data-action="click">
          {topProduct.description}
        </a>
        <div className="pricing" data-component="Pricing">
          <p className="price">
            {topProduct.isWebstaurantPlusEligible && <a href="/plus/" className="ribbon ribbon--mini ribbon--plus">
                <span className="ribbon__text">plus</span>
              </a>}
            {`${formatAsCurrency.formatIfUndefined(topProduct.price)}`}
            <span className="each uom">{` / ${topProduct.unitOfMeasure}`}</span>
          </p>
        </div>
      </div>
      <div className="ag-side-grid ag-mini">
        <AddToCartButton {...{
        product,
        user,
        selectedProduct,
        setSelectedProduct,
        isCarouselProductBox: true
      }} data-sentry-element="AddToCartButton" data-sentry-source-file="TopProductsGridMember.tsx" />
      </div>
    </div>;
};
export const mapStateToProps = (state: RootState) => ({
  user: state.user
});
export default connect(mapStateToProps)(TopProductsGridMember);